module.exports = __webpack_public_path__ + "static/mountains-8bf0394bbd9e458a267bd1b1b046d415.jpg";